



















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DemoServer from "../../shared/DemoServer";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";

import WorkshopJson from "../../shared/WorkshopJson";
import WorkshopBookingJson from "../../shared/WorkshopBookingJson";
import WorkshopPriceJson from "../../shared/WorkshopPriceJson";
import { WorkshopWithBookingsJson } from "../../shared/WorkshopJson";
import { WorkshopBookingStatus } from "../../shared/WorkshopBookingStatus";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import { Gender } from "../../shared/Gender";

import { validateWorkshopBookingJsonManagement } from "../../shared/WorkshopBookingJson";
import { validateWorkshopBookingJsonManagementAdd } from "../../shared/WorkshopBookingJson";
import { ValidationResult, Validation } from "../../shared/Validation";

import CustomerJson, { defaultCustomerJson } from "../../shared/CustomerJson";
import SepaMandateJson from "../../shared/SepaMandateJson";

import InvoiceInfoDetails from "../general/InvoiceInfoDetails.vue";

type keysForCachedPrices = {
  [key in keyof Pick<WorkshopBookingJson, "priceDeposit" | "priceNonDeposit" | "cancellationFee">]: string;
};

export default Vue.extend({
  name: "WorkshopBookingDetails",
  components: {
    OverlayWindow,
    Loading,
    InvoiceInfoDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    selectedWorkshopId: Number,
    selectedBookingId: Number,
    WorkshopsBookingStatusNames: Object,
    mode: String,
  },
  data() {
    return {
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      supportsDatePicker: false,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      Gender: Gender,
      genderNames: {
        male: "männlich",
        female: "weiblich",
        other: "divers",
      },
      WorkshopBookingStatus: WorkshopBookingStatus,
      detailsMode: "",
      workshopTitle: "" as string,
      workshopDetails: null as WorkshopWithBookingsJson | null,
      workshopBookingDetails: null as WorkshopBookingJson | null,
      selectedPriceIndex: null as number | null,
      cachedPrices: {
        priceDeposit: "0,00",
        priceNonDeposit: "0,00",
        cancellationFee: "0,00",
      } as keysForCachedPrices,
      cachedBirthDate: "" as string,
      useSepaMandate: false as boolean,
      hasChanges: false,
      hintChanged: {
        statusChanged: false as boolean,
        selectedPrice: false as boolean,
      },
      toValidate: {} as any,
      validation: null as ValidationResult<WorkshopBookingJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
      loadingNextup: false as boolean,
    };
  },
  created() {
    this.initWorkshopBookingDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
    this.setCachedBirthDate();
  },
  methods: {
    initWorkshopBookingDetails() {
      this.loadWorkshopDetails();
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    /*
      async loadWorkshopDetails() {
         if (this.selectedWorkshopId != null) {
            try {
               let allWorkshops = await this.restClient.getWorkshops()

               let selectedWorkshop = allWorkshops.find((item) => item.ID == this.selectedWorkshopId)
               if (selectedWorkshop !== undefined) {
                  this.workshopDetails = selectedWorkshop
               }

               this.selectDetailsMode(this.mode)
            } catch (e) {
               alert(e.message)
            }
         }
      },*/

    async loadWorkshopDetails() {
      if (this.selectedWorkshopId != null) {
        try {
          this.workshopDetails = await this.restClient.getWorkshopWithBookings(this.selectedWorkshopId);

          this.selectDetailsMode(this.mode);

          this.loadWorkshopBookingDetails();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadWorkshopBookingDetails() {
      if (this.selectedWorkshopId != null) {
        if (this.selectedBookingId != null) {
          try {
            let workshopBooking = await this.restClient.getWorkshopBooking(
              this.selectedWorkshopId,
              this.selectedBookingId
            );

            this.workshopBookingDetails = workshopBooking.booking;

            if (this.workshopBookingDetails.sepaMandate != null) {
              this.useSepaMandate = true;
            }

            this.setSelectedPriceIndex();
            this.setCachedPrices();
            this.setCachedBirthDate();
          } catch (e) {
            alert(e.message);
          }
        } else {
          this.loadDefaultBookingDetails();
          this.setDefaultPrices();
          this.setCachedPrices();
        }
      }
    },

    loadDefaultBookingDetails() {
      this.workshopBookingDetails = {
        ID: null,
        customer: this.getDefaultCustomer(),
        remarks: "",
        state: WorkshopBookingStatus.requested,
        selectedPriceTitle: "",
        selectedPriceRemarks: "",
        priceDeposit: 0,
        priceNonDeposit: 0,
        cancellationFee: 0,
        cancellationRemarks: "",
        bookingDateTime: new Date().toISOString(),
        sepaMandate: null,
        invoiceInfos: null,
      };
    },

    getDefaultCustomer(): CustomerJson {
      return defaultCustomerJson();
    },

    getDefaultSepaMandate(): SepaMandateJson {
      if (this.workshopBookingDetails != null) {
        return {
          ID: null,
          dateTime: new Date().toISOString(),
          lastUseDateTime: new Date().toISOString(),
          accountHolderFirstName: this.workshopBookingDetails.customer.guardianFirstName,
          accountHolderLastName: this.workshopBookingDetails.customer.guardianLastName,
          addressStreet: this.workshopBookingDetails.customer.addressStreet,
          addressZip: this.workshopBookingDetails.customer.addressZip,
          addressCity: this.workshopBookingDetails.customer.addressCity,
          addressCountry: this.workshopBookingDetails.customer.addressCountry,
          IBAN: "",
          BIC: "",
        };
      } else {
        return {
          ID: null,
          dateTime: new Date().toISOString(),
          lastUseDateTime: new Date().toISOString(),
          accountHolderFirstName: "",
          accountHolderLastName: "",
          addressStreet: "",
          addressZip: "",
          addressCity: "",
          addressCountry: "Deutschland",
          IBAN: "",
          BIC: "",
        };
      }
    },

    setDefaultPrices() {
      if (this.workshopBookingDetails != null && this.workshopDetails != null) {
        this.selectedPriceIndex = 0;
        this.setSelectedPriceTitleAndRemarks();

        this.workshopBookingDetails.priceDeposit = this.workshopDetails.prices[0].priceDeposit;
        this.workshopBookingDetails.priceNonDeposit = this.workshopDetails.prices[0].priceNonDeposit;
        this.workshopBookingDetails.cancellationFee = this.workshopDetails.prices[0].cancellationFee;
        this.workshopBookingDetails.cancellationRemarks = this.workshopDetails.prices[0].cancellationRemarks;
      }
    },

    setSelectedPriceIndex() {
      if (this.workshopDetails != null && this.workshopBookingDetails != null) {
        let selectedPrice = this.workshopDetails.prices.findIndex(
          (i: any) => i.title == this.workshopBookingDetails?.selectedPriceTitle
        );

        if (selectedPrice >= 0) {
          this.selectedPriceIndex = selectedPrice;
        } else {
          this.selectedPriceIndex = null;
        }
      }
    },

    //START set cached data

    setCachedPrices() {
      if (this.workshopBookingDetails != null) {
        let k = this.cachedPrices;
        let i: keyof typeof k;

        for (i in this.cachedPrices) {
          let price = this.getFormatPrice(this.workshopBookingDetails[i]);

          this.cachedPrices[i] = price;
        }
      }
    },

    setCachedBirthDate() {
      if (this.workshopBookingDetails != null && this.workshopBookingDetails.customer != null) {
        if (this.supportsDatePicker) {
          this.cachedBirthDate = this.workshopBookingDetails.customer.childBirthDate!;
        } else {
          let d = new Date(this.workshopBookingDetails.customer.childBirthDate!);

          if (d != null) {
            this.cachedBirthDate = DateFormatter.formatDateMedium(d);
          }
        }
      }
    },

    //END set cached data

    async reloadDetailsView() {
      if (this.selectedWorkshopId != null && this.selectedBookingId != null) {
        this.workshopBookingDetails = null;
        try {
          let workshopBooking = await this.restClient.getWorkshopBooking(
            this.selectedWorkshopId,
            this.selectedBookingId
          );

          this.workshopBookingDetails = workshopBooking.booking;

          if (this.workshopBookingDetails.sepaMandate != null) {
            this.useSepaMandate = true;
          }

          this.setCachedPrices();
          this.setCachedBirthDate();

          this.$nextTick(() => {
            this.hasChanges = false;
          });
        } catch (e) {
          alert(e.message);
        }
      } else {
        this.closeDetails();
      }
    },

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Buchung hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Buchung bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Buchung für " + this.workshopDetails?.title;
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        this.selectDetailsMode("show");
        this.reloadDetailsView();
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.selectDetailsMode("show");
          this.reloadDetailsView();
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.workshopBookingDetails != null) {
        this.validation = validateWorkshopBookingJsonManagement(this.workshopBookingDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    setSelectedPriceTitleAndRemarks() {
      if (this.workshopDetails != null && this.workshopBookingDetails != null && this.selectedPriceIndex != null) {
        this.workshopBookingDetails.selectedPriceTitle = this.workshopDetails.prices[this.selectedPriceIndex].title;
        this.workshopBookingDetails.selectedPriceRemarks = this.workshopDetails.prices[this.selectedPriceIndex].remarks;
      }
    },

    setSelectedPricePrices() {
      if (this.workshopDetails != null && this.workshopBookingDetails != null && this.selectedPriceIndex != null) {
        let selectedPrice = this.workshopDetails.prices[this.selectedPriceIndex];

        this.workshopBookingDetails.priceDeposit = selectedPrice.priceDeposit;
        this.workshopBookingDetails.priceNonDeposit = selectedPrice.priceNonDeposit;
        this.workshopBookingDetails.cancellationFee = selectedPrice.cancellationFee;
        this.workshopBookingDetails.cancellationRemarks = selectedPrice.cancellationRemarks;
      }
    },

    //START set input data (where data be cached)

    formatAndSetCachedPrices(key: keyof keysForCachedPrices) {
      if (this.workshopBookingDetails != null) {
        let price = this.cachedPrices[key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedPrices[key] = price;
        this.workshopBookingDetails[key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    setBirthDate() {
      if (this.workshopBookingDetails != null && this.workshopBookingDetails.customer != null) {
        var birthDate = "";

        if (this.supportsDatePicker) {
          birthDate = this.cachedBirthDate;
        } else {
          if (this.cachedBirthDate.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedBirthDate);

            if (d != null) {
              birthDate = DateFormatter.formatISODate(d);
            }
          }
        }

        this.workshopBookingDetails.customer.childBirthDate = birthDate;
      }
    },

    //END set input data (where data be cached)

    toggleUseSepaMandate() {
      if (this.workshopBookingDetails != null) {
        if (this.useSepaMandate) {
          this.workshopBookingDetails.sepaMandate = null;
          this.useSepaMandate = false;
        } else {
          this.workshopBookingDetails.sepaMandate = this.getDefaultSepaMandate();
          this.useSepaMandate = true;
        }
      }
    },

    async saveWorkshopBookingDetails() {
      if (this.workshopBookingDetails != null && this.selectedWorkshopId) {
        if (this.hasChanges) {
          this.loadingGeneral = true;

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateWorkshopBookingJsonManagement(this.workshopBookingDetails);
          //todo ###END

          if (this.validation != null && this.validation.isValid == true) {
            if (this.restClient != null) {
              try {
                let updatedWorkshopDetails = await this.restClient.updateWorkshopBooking(
                  this.selectedWorkshopId,
                  this.workshopBookingDetails
                );

                alert("Die Änderungen wurden erfolgreich gespeichert.");

                this.$nextTick(() => {
                  this.hasChanges = false;
                  this.loadingGeneral = false;
                  this.stopEditMode();
                });
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async addNewWorkshopBooking() {
      if (this.workshopBookingDetails != null && this.selectedWorkshopId != null) {
        this.loadingGeneral = true;

        //set prices
        this.setSelectedPricePrices();

        this.validation = validateWorkshopBookingJsonManagementAdd(this.workshopBookingDetails);

        this.submitValidation = true;

        if (this.validation != null && this.validation.isValid == true) {
          try {
            this.workshopBookingDetails = await this.restClient.addWorkshopBooking(
              this.selectedWorkshopId,
              this.workshopBookingDetails
            );
            alert("Die Buchung wurde erfolgreich hinzugefügt.");
            this.$nextTick(() => {
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.stopEditMode();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Die Buchung konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async deleteWorkshopBooking() {
      if (this.selectedWorkshopId != null && this.selectedBookingId != null) {
        let c = confirm("Wollen Sie diese Buchung wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteWorkshopBooking(this.selectedWorkshopId, this.selectedBookingId);
              this.closeDetails();
              alert("Die Buchung wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    async sendBookingConfirmation() {
      this.loadingNextup = true;

      if (this.hasChanges) {
        await this.saveWorkshopBookingDetails();
      }

      if (this.selectedWorkshopId != null && this.selectedBookingId != null && this.restClient != null) {
        try {
          await this.restClient.confirmWorkshopBooking(this.selectedWorkshopId, this.selectedBookingId);
          alert("Es wurde eine Bestätigung an den Kunden gesendet.");
          this.hasChanges = false;
          this.stopEditMode();
          this.loadingNextup = false;
        } catch (e) {
          alert(e.message);
          this.loadingNextup = false;
        }
      }
    },

    async cancelWorkshopBooking() {
      if (!this.hasChanges) {
        if (this.workshopBookingDetails != null && this.selectedWorkshopId != null) {
          let c = confirm(
            "Wollen Sie die Absage per E-Mail bestätigen? Die Buchung wird unter Berücksichtigung der Stornierungsgebühr (€ " +
              this.getFormatPrice(this.workshopBookingDetails.cancellationFee) +
              ") abgesagt."
          );
          if (c == true) {
            this.loadingGeneral = true;

            if (this.restClient != null) {
              try {
                await this.restClient.cancelWorkshopBooking(this.selectedWorkshopId, this.selectedBookingId);
                this.closeDetails();
                alert("Die Buchung wurde erfolgreich abgesagt.");

                this.loadingGeneral = false;
              } catch (e) {
                alert(e.message);

                this.loadingGeneral = false;
              }
            }
          } else {
            //do nothing
          }
        }
      } else {
        alert("Bitte speichern Sie zuvor die letzten Änderungen.");
      }
    },

    // print
    printBookingDetails() {
      var toPrint = document.getElementById("toPrint");

      if (toPrint != null) {
        var eles = this.$el.querySelectorAll(".print-view");

        for (let i = 0; i < eles.length; i++) {
          toPrint.appendChild(eles[i].cloneNode(true));
        }
      }

      this.$nextTick(() => {
        window.print();
      });

      this.$nextTick(() => {
        while (toPrint?.lastElementChild) {
          toPrint.removeChild(toPrint.lastElementChild);
        }
      });
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    workshopBookingDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    workshopRegistrationsLeftText(): string {
      if (this.workshopDetails != null) {
        const maxRegistrationCount = this.workshopDetails.registrationMaximumCount;
        let registrationCount = 0;

        for (let i = 0; i < this.workshopDetails.bookings.length; i++) {
          if (
            this.workshopDetails.bookings[i].state != "requested" &&
            this.workshopDetails.bookings[i].state != "canceled" &&
            this.workshopDetails.bookings[i].state != "cancellationFeeExported" &&
            this.workshopDetails.bookings[i].state != "waitingList"
          ) {
            registrationCount++;
          }
        }

        if (maxRegistrationCount === undefined) {
          return "Freie Plätze: [Fehler]";
        }

        let registrationsLeft = maxRegistrationCount - registrationCount;

        if (registrationsLeft < 0) {
          return "Bereits überbucht";
        } else if (registrationsLeft == 1) {
          return "Noch 1 freier Platz";
        } else {
          return "Noch " + registrationsLeft + " freie Plätze";
        }
      }

      return "Lade freie Plätze...";
    },

    isDepositPaymentRequired(): boolean {
      if (this.workshopBookingDetails != null) {
        if (this.workshopBookingDetails.state == WorkshopBookingStatus.bookedDepositPaymentExported) {
          if (this.workshopBookingDetails.priceDeposit === 0) {
            return false;
          }
        }
      }

      return true;
    },

    formatIBAN: {
      get(): string | undefined {
        if (this.workshopBookingDetails != null) {
          if (this.workshopBookingDetails.sepaMandate != null) {
            return this.workshopBookingDetails.sepaMandate.IBAN.toUpperCase()
              .replace(/[^0-9A-Z]/g, "")
              .replace(/(.{1,4})/g, "$1 ")
              .trim();
          }
        }
      },
      set(value: string) {
        if (this.workshopBookingDetails != null) {
          if (this.workshopBookingDetails.sepaMandate != null) {
            this.workshopBookingDetails.sepaMandate.IBAN = value;
          }
        }
      },
    },
  },
});
